import * as React from 'react';
import styled from 'styled-components';
import DisplayText from '@sdk/components/ui/DisplayText';

const PLUS_COLOR = 'rgba(0, 0, 0, 0.25)';

const Container = styled.div`
  cursor: pointer;
  display: flex;
  width: 35px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border: 2px solid ${PLUS_COLOR};
  align-items: center;
  justify-content: center;
  margin-left: 2px;
`;

type Props = {
  className?: string;
  isHovered: boolean;
};
const BoxPlusIcon: React.FC<React.PropsWithChildren<Props>> = ({ className, isHovered }) => {
  if (!isHovered) {
    return null;
  }
  return (
    <Container className={className}>
      <DisplayText fontSize={30} lineHeight={30} color={PLUS_COLOR}>
        +
      </DisplayText>
    </Container>
  );
};

export default BoxPlusIcon;
